import { Component } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentBase } from '../component-base.component';
import { ListRetrieverService } from '../../_services/list-retriever.service';
import { Option } from '../../_models/option';
import { Utils } from '../../utils';
import { DataContext } from '../../_models/data-context';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.css']
})
export class HomepageComponent extends ComponentBase {
  error;

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected location: Location,
  ) {
    super(route, router, location);
  }

  getHomepageRoute(): string {
    return '/';
  }

  onInit(): void {
    this.isLoading = false;
  }

  submit() { }
}



// WEBPACK FOOTER //
// ./src/app/components/homepage/homepage.component.ts